export const scrollToSection = (hash) => {
    const el = document.querySelector(hash);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};

export const goToVideoPoem = (videoId) => {
    scrollToSection("#video-poesia");
    window.dispatchEvent(new CustomEvent("show-video", { detail: videoId }));
};
